import { render, staticRenderFns } from "./testError.vue?vue&type=template&id=33294238"
import script from "./testError.vue?vue&type=script&lang=js"
export * from "./testError.vue?vue&type=script&lang=js"
import style0 from "./testError.vue?vue&type=style&index=0&id=33294238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports